const approveArrivalHm = {
	id: 'approveArrivalHm',
	selectionType: 'single',
	label: 'action.anchorageoperations.approveArrivalHm',
	functionality: 'ANCHORAGE_APPROVE_ARRIVAL_HM',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const row = registries[0];
			const status = row.arrivalhmstatus;
			if (row.departurerequestdate) return false;
			return row.arrivalrequestdate && (status === 'PENDING' || status === 'DENIED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsApproveArrivalHm-anchorageoperations-show', row);
	}
};

const approveArrivalCuof = {
	id: 'approveArrivalCuof',
	selectionType: 'single',
	label: 'action.anchorageoperations.approveArrivalCuof',
	functionality: 'ANCHORAGE_APPROVE_ARRIVAL_CUOF',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const row = registries[0];
			const status = row.arrivalcuofstatus;
			if (row.departurerequestdate) return false;
			return row.arrivalrequestdate && (status === 'PENDING' || status === 'DENIED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsApproveArrivalCuof-anchorageoperations-show', row);
	}
};

const approveArrivalPp = {
	id: 'approveArrivalPp',
	selectionType: 'single',
	label: 'action.anchorageoperations.approveArrivalPp',
	functionality: 'ANCHORAGE_APPROVE_ARRIVAL_PP',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const row = registries[0];
			const status = row.arrivalppstatus;
			if (row.departurerequestdate) return false;
			return row.arrivalrequestdate && (status === 'PENDING' || status === 'DENIED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsApproveArrivalPp-anchorageoperations-show', row);
	}
};

const denyArrivalCuof = {
	id: 'denyArrivalCuof',
	selectionType: 'single',
	label: 'action.anchorageoperations.denyArrivalCuof',
	functionality: 'ANCHORAGE_APPROVE_ARRIVAL_CUOF',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const row = registries[0];
			const status = row.arrivalcuofstatus;
			if (row.departurerequestdate) return false;
			return row.arrivalrequestdate && (status === 'PENDING' || status === 'APPROVED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsDenyArrivalCuof-anchorageoperations-show', row);
	}
};

const denyArrivalPp = {
	id: 'denyArrivalPp',
	selectionType: 'single',
	label: 'action.anchorageoperations.denyArrivalPp',
	functionality: 'ANCHORAGE_APPROVE_ARRIVAL_PP',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const row = registries[0];
			const status = row.arrivalppstatus;
			if (row.departurerequestdate) return false;
			return row.arrivalrequestdate && (status === 'PENDING' || status === 'APPROVED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsDenyArrivalPp-anchorageoperations-show', row);
	}
};

const denyArrivalHm = {
	id: 'denyArrivalHm',
	selectionType: 'single',
	label: 'action.anchorageoperations.denyArrivalHm',
	functionality: 'ANCHORAGE_APPROVE_ARRIVAL_HM',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const row = registries[0];
			const status = row.arrivalhmstatus;
			if (row.departurerequestdate) return false;
			return row.arrivalrequestdate && (status === 'PENDING' || status === 'APPROVED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsDenyArrivalHm-anchorageoperations-show', row);
	}
};

const approveDepartureHm = {
	id: 'approveDepartureHm',
	selectionType: 'single',
	label: 'action.anchorageoperations.approveDepartureHm',
	functionality: 'ANCHORAGE_APPROVE_DEPARTURE_HM',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const status = registries[0].departurehmstatus;
			return registries && registries[0].departurerequestdate && (status === 'PENDING' || status === 'DENIED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsApproveDepartureHm-anchorageoperations-show', row);
	}
};

const denyDepartureCuof = {
	id: 'denyDepartureCuof',
	selectionType: 'single',
	label: 'action.anchorageoperations.denyDepartureCuof',
	functionality: 'ANCHORAGE_APPROVE_DEPARTURE_CUOF',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const status = registries[0].departurecuofstatus;
			return registries && registries[0].departurerequestdate && (status === 'PENDING' || status === 'APPROVED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsDenyDepartureCuof-anchorageoperations-show', row);
	}
};

const approveDepartureCuof = {
	id: 'approveDepartureCuof',
	selectionType: 'single',
	label: 'action.anchorageoperations.approveDepartureCuof',
	functionality: 'ANCHORAGE_APPROVE_DEPARTURE_CUOF',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const status = registries[0].departurecuofstatus;
			return registries && registries[0].departurerequestdate && (status === 'PENDING' || status === 'DENIED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsApproveDepartureCuof-anchorageoperations-show', row);
	}
};

const approveDeparturePp = {
	id: 'approveDeparturePp',
	selectionType: 'single',
	label: 'action.anchorageoperations.approveDeparturePp',
	functionality: 'ANCHORAGE_APPROVE_DEPARTURE_PP',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const status = registries[0].departureppstatus;
			return registries && registries[0].departurerequestdate && (status === 'PENDING' || status === 'DENIED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsApproveDeparturePp-anchorageoperations-show', row);
	}
};

const denyDepartureHm = {
	id: 'denyDepartureHm',
	selectionType: 'single',
	label: 'action.anchorageoperations.denyDepartureHm',
	functionality: 'ANCHORAGE_APPROVE_DEPARTURE_HM',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const status = registries[0].departurehmstatus;
			return registries && registries[0].departurerequestdate && (status === 'PENDING' || status === 'APPROVED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsDenyDepartureHm-anchorageoperations-show', row);
	}
};

const denyDeparturePp = {
	id: 'denyDeparturePp',
	selectionType: 'single',
	label: 'action.anchorageoperations.denyDeparturePp',
	functionality: 'ANCHORAGE_APPROVE_DEPARTURE_PP',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const status = registries[0].departureppstatus;
			return registries && registries[0].departurerequestdate && (status === 'PENDING' || status === 'APPROVED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-anchorageoperationsDenyDeparturePp-anchorageoperations-show', row);
	}
};

export default {
	gridactions: [approveArrivalHm, denyArrivalHm, approveArrivalCuof, denyArrivalCuof, approveArrivalPp, denyArrivalPp, approveDepartureHm, denyDepartureHm, approveDepartureCuof, denyDepartureCuof, approveDeparturePp, denyDeparturePp],
	formactions: [approveArrivalHm, denyArrivalHm, approveArrivalCuof, denyArrivalCuof, approveArrivalPp, denyArrivalPp, approveDepartureHm, denyDepartureHm, approveDepartureCuof, denyDepartureCuof, approveDeparturePp, denyDeparturePp]
}


